






import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import moment from "moment";

@Component({
  computed: {
    ...mapGetters("ui", ["nightMode", "login"]),
  },
})
export default class HeaderLoginMobile extends Vue {
  private nightMode: boolean;
  private login: string;
}
